import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        backgroundColor: "#fafafa",
        minHeight: "100vh",
      }}
    >
      <header
        style={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #e5e5e5",
          padding: "1rem 2rem",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <nav
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <a
            href="/"
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              letterSpacing: "-0.5px",
              textDecoration: "none",
            }}
          >
            Collavo
          </a>

          <a
            href="/"
            style={{
              backgroundColor: "transparent",
              color: "#1a1a1a",
              padding: "10px 24px",
              fontSize: "15px",
              fontWeight: "500",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              textDecoration: "none",
              display: "inline-block",
            }}
          >
            Back to Home
          </a>
        </nav>
      </header>

      <main
        style={{
          maxWidth: "600px",
          margin: "0 auto",
          padding: "4rem 2rem",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "3rem",
          }}
        >
          <h1
            style={{
              fontSize: "48px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
              letterSpacing: "-1px",
            }}
          >
            Get In Touch
          </h1>
          <p
            style={{
              fontSize: "18px",
              color: "#525252",
              lineHeight: "1.6",
            }}
          >
            Have questions, feedback, or need help? We'd love to hear from you.
          </p>
        </div>

        <div
          style={{
            backgroundColor: "#fff",
            padding: "3rem",
            borderRadius: "12px",
            border: "1px solid #e5e5e5",
          }}
        >
          <form action="https://formsubmit.co/sam@collavo.co" method="POST">
            <div style={{ marginBottom: "1.5rem" }}>
              <label
                htmlFor="name"
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#525252",
                  marginBottom: "8px",
                }}
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: "15px",
                  color: "#1a1a1a",
                  backgroundColor: "#fff",
                  border: "1px solid #e5e5e5",
                  borderRadius: "8px",
                  outline: "none",
                  transition: "border-color 0.2s ease",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => (e.currentTarget.style.borderColor = "#a3a3a3")}
                onBlur={(e) => (e.currentTarget.style.borderColor = "#e5e5e5")}
              />
            </div>

            <div style={{ marginBottom: "1.5rem" }}>
              <label
                htmlFor="email"
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#525252",
                  marginBottom: "8px",
                }}
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: "15px",
                  color: "#1a1a1a",
                  backgroundColor: "#fff",
                  border: "1px solid #e5e5e5",
                  borderRadius: "8px",
                  outline: "none",
                  transition: "border-color 0.2s ease",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => (e.currentTarget.style.borderColor = "#a3a3a3")}
                onBlur={(e) => (e.currentTarget.style.borderColor = "#e5e5e5")}
              />
            </div>

            <div style={{ marginBottom: "1.5rem" }}>
              <label
                htmlFor="subject"
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#525252",
                  marginBottom: "8px",
                }}
              >
                Subject
              </label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: "15px",
                  color: "#1a1a1a",
                  backgroundColor: "#fff",
                  border: "1px solid #e5e5e5",
                  borderRadius: "8px",
                  outline: "none",
                  transition: "border-color 0.2s ease",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => (e.currentTarget.style.borderColor = "#a3a3a3")}
                onBlur={(e) => (e.currentTarget.style.borderColor = "#e5e5e5")}
              />
            </div>

            <div style={{ marginBottom: "1.5rem" }}>
              <label
                htmlFor="message"
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#525252",
                  marginBottom: "8px",
                }}
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={6}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: "15px",
                  color: "#1a1a1a",
                  backgroundColor: "#fff",
                  border: "1px solid #e5e5e5",
                  borderRadius: "8px",
                  outline: "none",
                  transition: "border-color 0.2s ease",
                  boxSizing: "border-box",
                  fontFamily: "inherit",
                  resize: "vertical",
                }}
                onFocus={(e) => (e.currentTarget.style.borderColor = "#a3a3a3")}
                onBlur={(e) => (e.currentTarget.style.borderColor = "#e5e5e5")}
              />
            </div>

            <input type="hidden" name="_captcha" value="false" />

            <button
              type="submit"
              style={{
                width: "100%",
                backgroundColor: "#000",
                color: "#fff",
                padding: "14px 20px",
                fontSize: "15px",
                fontWeight: "600",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                marginTop: "1rem",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#333";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#000";
              }}
            >
              Send Message
            </button>
          </form>
        </div>

        {/* <div
          style={{
            marginTop: "3rem",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontSize: "15px",
              color: "#737373",
              marginBottom: "1rem",
            }}
          >
            Or email us directly at
          </p>

          <a
            href="mailto:sam@collavo.co"
            style={{
              fontSize: "18px",
              fontWeight: "500",
              color: "#1a1a1a",
              textDecoration: "none",
            }}
          >
            sam@collavo.co
          </a>
        </div> */}
      </main>

      <footer
        style={{
          borderTop: "1px solid #e5e5e5",
          backgroundColor: "#fff",
          padding: "2rem",
          marginTop: "4rem",
        }}
      >
        <div
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "#737373",
              marginBottom: "1rem",
            }}
          >
            <a
              href="/about"
              style={{
                color: "#737373",
                textDecoration: "none",
                marginRight: "1.5rem",
              }}
            >
              About
            </a>

            <a
              href="/privacy"
              style={{
                color: "#737373",
                textDecoration: "none",
                marginRight: "1.5rem",
              }}
            >
              Privacy Policy
            </a>

            <a
              href="/terms"
              style={{ color: "#737373", textDecoration: "none" }}
            >
              Terms of Service
            </a>
          </p>
          <p style={{ fontSize: "14px", color: "#737373" }}>
            © 2025 Collavo. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
